console.log(process.env.NODE_ENV)
const config = {
  route: (process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'development') ? 'https://bpjs-api.pasarpolis.com' : 'https://bpjs-api-prod.pasarpolis.com'
}

export default config


// WEBPACK FOOTER //
// ./src/config.js